import {api as mockApi} from './mockApi';

const API_URL = import.meta.env.DEV ? 'http://localhost:3002/api' : '/api';

const getHeaders = () => ({
  'Content-Type': 'application/json',
  Authorization: `Bearer ${localStorage.getItem('advent_token')}`
});

const fetchJson = async (url, options = {}) => {
  const response = await fetch(url, options);
  const contentType = response.headers.get('content-type') || '';

  if (!response.ok) {
    let message = `Server Fehler: ${response.status}`;

    if (contentType.includes('application/json')) {
      const errorData = await response.json();
      message = errorData.error || message;
    }

    throw new Error(message);
  }

  return contentType.includes('application/json')
    ? response.json()
    : null;
};

export const api = {
  getDoors: async () => {
    try {
      return await fetchJson(`${API_URL}/doors`);
    } catch (error) {
      if (import.meta.env.DEV) return mockApi.getDoors();
      throw error;
    }
  },

  getSettings: async () => {
    try {
      return await fetchJson(`${API_URL}/settings`);
    } catch (error) {
      if (import.meta.env.DEV) return mockApi.getSettings();
      throw error;
    }
  },

  login: async (username, password) => {
    try {
      const data = await fetchJson(`${API_URL}/auth/login`, {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({
          username: username.trim(),
          password
        })
      });

      if (data?.token) {
        localStorage.setItem('advent_token', data.token);
      }

      return data;
    } catch (error) {
      if (import.meta.env.DEV && error.message.includes('Failed to fetch')) {
        const data = await mockApi.login(username, password);
        localStorage.setItem('advent_token', data.token);
        return data;
      }

      throw error;
    }
  },

  changePassword: (newPassword) => fetchJson(`${API_URL}/auth/change-password`, {
    method: 'PUT',
    headers: getHeaders(),
    body: JSON.stringify({newPassword})
  }),

  deleteAsset: (type) => fetchJson(`${API_URL}/upload/${type}`, {
    method: 'DELETE',
    headers: getHeaders()
  }),

  logout: () => {
    localStorage.removeItem('advent_token');
    mockApi.logout();
  },

  isAuthenticated: () => Boolean(localStorage.getItem('advent_token')),

  updateDoor: (id, data) => fetchJson(`${API_URL}/doors/${id}`, {
    method: 'PUT',
    headers: getHeaders(),
    body: JSON.stringify(data)
  }),

  updateSettings: (data) => fetchJson(`${API_URL}/settings`, {
    method: 'PUT',
    headers: getHeaders(),
    body: JSON.stringify(data)
  }),

  uploadAsset: async (file, type) => {
    const formData = new FormData();
    formData.append(type, file);

    const response = await fetch(`${API_URL}/upload`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('advent_token')}`
      },
      body: formData
    });

    if (!response.ok) {
      throw new Error('Upload fehlgeschlagen');
    }

    return response.json();
  }
};